module.exports = __webpack_public_path__ + "teqbahn-assets/media/sharestorywhite.74913fc1.png";